export const SESSION_STORAGE_CHUNK_RELOAD_KEY = '::zenbusiness::chunk-reload-attempted';

/**
 * Clears the reload gate so future navigations can still retry on chunk failure.
 */
export function clearChunkReloadFlag() {
  sessionStorage.removeItem(SESSION_STORAGE_CHUNK_RELOAD_KEY);
}

/**
 * Reloads once on chunk failure (sessionStorage-gated).
 * Returns true if a reload was initiated, false otherwise.
 * Re-import retry alone won't work because browsers cache failed dynamic imports in the module map.
 *
 * @param {Error} error
 * @returns {boolean}
 */
export function handleChunkLoadError(error) {
  const isChunkLoadError = error?.name === 'ChunkLoadError';
  const hasReloaded = sessionStorage.getItem(SESSION_STORAGE_CHUNK_RELOAD_KEY);

  if (!isChunkLoadError || hasReloaded) {
    return false;
  }

  sessionStorage.setItem(SESSION_STORAGE_CHUNK_RELOAD_KEY, '1');
  window.location.reload();

  return true;
}
